import React from 'react';

import classes from './LinkIcon.css';

const linkIcon = (props) => (
  <a
    className={[classes.Button, props.btnClass, props.btnType ? classes[props.btnType] : null, props.small ? classes.Small : null].join(' ')}
    href={props.link}
    style={props.style}
    disabled={props.disabled}>
    <img className={props.iconClass} src={props.iconSource} alt={props.iconAlt} />
    <p className={classes.ButtonText}>{props.children}</p>
  </a>
);

export default linkIcon;



// WEBPACK FOOTER //
// ./src/components/UI/LinkIcon/LinkIcon.js